import { Directive, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
    selector: '[hlmCardContent]',
    host: {
        '[class]': '_computedClass()',
    },
})
export class HlmCardContent {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected readonly _computedClass = computed(() => hlm('px-md text-text-secondary', this.userClass()));
}
